export const YOUTUBE_IFRAME_SCRIPT_URL = 'https://www.youtube.com/iframe_api';

export const getYoutubeImage = (youtubeVideoId: number | string) =>
  `https://img.youtube.com/vi/${youtubeVideoId}/maxresdefault.jpg`;
